
<div class="loader">
    <mat-spinner></mat-spinner>
    <p> {{message}} </p>
  </div>